import mutations from './employabilityImport.mutations'
import actions from './employabilityImport.actions'
import getters from './employabilityImport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
